<div class="checked">
  @if (checked()) {
    <i>checked</i>
  }
</div>
<div class="icon">
  @if (shape() !== undefined) {
    <i [innerHtml]="shape()" [ngStyle]="style()"></i>
  }
</div>
<div class="label" [innerHtml]="label()"></div>
@if (disabled() && reason().length > 0) {
  <app-tooltip class="info" icon="help_outline">{{ reason() }}</app-tooltip>
} @else {
  <div class="info"></div>
}
<div class="expand"></div>
